module.exports = __webpack_public_path__ + "img/mbs-logo.6b43004d.png";